import { ITK_CATALOG_ARCHIVE_URL } from '../../../../config';

function DownloadCatalogBtn() {
    return (
        <button className="btn btn--filled">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.5"
                height="14"
                viewBox="0 0 10.5 14"
                style={{ marginRight: '0.625rem' }}
            >
                <path
                    id="_"
                    className="cls-1"
                    style={{ fill: '#fff', fillRule: 'evenodd' }}
                    d="M1285.57,9177.61v-3.72h-5.47a0.651,0.651,0,0,0-.65.66v12.68a0.651,0.651,0,0,0,.65.66h9.19a0.659,0.659,0,0,0,.66-0.66v-8.96h-3.72A0.666,0.666,0,0,1,1285.57,9177.61Zm2.09,5.78-2.63,2.62a0.471,0.471,0,0,1-.66,0l-2.64-2.62a0.441,0.441,0,0,1,.31-0.75h1.78v-2.19a0.435,0.435,0,0,1,.44-0.43h0.88a0.427,0.427,0,0,1,.43.43v2.19h1.78A0.436,0.436,0,0,1,1287.66,9183.39Zm2.1-6.63-2.68-2.68a0.665,0.665,0,0,0-.47-0.19h-0.16v3.5h3.5v-0.17A0.678,0.678,0,0,0,1289.76,9176.76Z"
                    transform="translate(-1279.44 -9173.91)"
                />
            </svg>
            <a href={ITK_CATALOG_ARCHIVE_URL} download>
                <span className="btn__txt">
                    Скачать <span className="edited">полный</span> каталог
                </span>
            </a>
        </button>
    );
}

export default DownloadCatalogBtn;
